import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withHocName from './with-hoc-name';
import withLayoutProps from './with-layout-props';
import withIsFeedDesignEnabled from './with-is-feed-design-enabled';
import { isLayoutTextOnImage } from '@wix/communities-blog-client-common';
import { getFeedColorClassName } from '../services/layout-config';

import styles from '../components/post-list-item/post-list-item.scss';

const layoutColorClasses = (getPostClassName, getFeedColorClassName, layoutName) => ({
  iconColorClassName: classNames(
    getPostClassName(
      getFeedColorClassName(layoutName, 'description-fill'),
      getFeedColorClassName(layoutName, 'active-hover-fill'),
    ),
  ),
  textColorClassName: classNames(
    getPostClassName(
      getFeedColorClassName(layoutName, 'description-color'),
      getFeedColorClassName(layoutName, 'description-fill'),
      'description-font',
    ),
  ),
  separatorBackgroundColorClassName: classNames(
    getPostClassName(getFeedColorClassName(layoutName, 'description-background-color')),
  ),
});

const layoutColorClassesBeforeMigration = (
  layoutType,
  iconColorClassName,
  textColorClassName,
  separatorBackgroundColorClassName,
) =>
  isLayoutTextOnImage(layoutType)
    ? {
        iconColorClassName: styles.textOnImageIcons,
        textColorClassName: styles.textOnImageTextColor,
        separatorBackgroundColorClassName: styles.textOnImageSeperatorBackgroundColor,
      }
    : {
        iconColorClassName: iconColorClassName || 'blog-icon-fill',
        textColorClassName: textColorClassName || 'blog-text-color',
        separatorBackgroundColorClassName: separatorBackgroundColorClassName || 'blog-separator-background-color',
      };

const mapStateToProps = (
  _state,
  {
    applyFeedDesign,
    layoutType,
    layoutName,
    getPostClassName,
    iconColorClassName,
    textColorClassName,
    separatorBackgroundColorClassName,
  },
) =>
  applyFeedDesign
    ? layoutColorClasses(getPostClassName, getFeedColorClassName, layoutName)
    : layoutColorClassesBeforeMigration(
        layoutType,
        iconColorClassName,
        textColorClassName,
        separatorBackgroundColorClassName,
      );

// prettier-ignore
export default flowRight(
  withLayoutProps({ fallbackEnabled: false }),
  withIsFeedDesignEnabled,
  connect(mapStateToProps),
  withHocName('WithLayoutColorClasses'),
);
